(function() {

/**
 * General utils
 * @module base
 * @class Utils
 * @namespace rwgps
 */
module.exports = {
    Utils: {
      /** Truncate text
       * @method truncate
       * @static
       * @param {String} text Text to truncate
       * @param {int} len Maximum length of truncated text
       * @return {String} Truncated text
       */
      truncate: function(text, len) {
        if(text == undefined || text.length == 0) return '';
        if(text.length <= len) return text;
        return text.slice(0, len) + "&#133;";
      },
      /** Build attribute object from jquery's serializeArray output
       * @method attrObjFromSerializedArray
       * @static
       * @param {Array} arr Array to convert
       * @return {Object} Object with keys/values corresponding to attr names / values
       */
      attrObjFromSerializedArray: function(arr) {
        return _.reduce(arr, function(memo, attrPair) {
          memo[attrPair.name] = attrPair.value;
          return memo;
        }, {});
      },
      /** nl2br and autolink text
       * @method formatText
       * @static
       * @param {String} text Text to format
       * @return {String} Formatted HTML
       */
      formatText: function(text) {
        if(!text) text = '';
        text = text.replace(/\r\n?/g, "\n");
        text = text.replace(/\n+$/, '');
        text = "<p>" + text + "</p>";
        text = text.replace(/\n\n+/g, '</p><p>');
        text = text.replace(/\n/g, '<br/>');
        return this.autolink(text);
      },
      /** autolink text, turns http://blah.com into <a href="http://blah.com">http://blah.com</a>
       * @method autolink
       * @static
       * @param {String} text Text to autolink
       * @return {String} HTML with links
       */
      autolink: function(text, attrs) {
        var key, link_attributes, url_pattern, value;
        url_pattern = /(\b(https?):\/\/[\-A-Z0-9+&@#\/%?=~_|!:,.;]*[\-A-Z0-9+&@#\/%=~_|])/ig;
        if (attrs) {
          link_attributes = '';
          for (key in attrs) {
            value = attrs[key];
            link_attributes += " " + key + "='" + value + "'";
          }
          return text.replace(url_pattern, "<a href='$1' " + link_attributes.trim() + ">$1</a>");
        } else {
          return text.replace(url_pattern, "<a href='$1'>$1</a>");
        }
      },
      /** format a number into a string with commas
       * thanks http://www.mredkj.com/javascript/nfbasic.html
       * @method addCommas
       * @static
       * @param {Number|String} nStr number or string to add commas to
       * @return {String} Number with commas
       */
      addCommas: function(nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
      },
      /** parse query string parameters
       * https://css-tricks.com/snippets/jquery/get-query-params-object/
       * @method getQueryParameters
       * @static
       * @param {String} str window.location.search or similar
       * @return {Object} An object of keys and values parsed from the querystring
       */
      getQueryParameters: function(str) {
        return (str || document.location.search).replace(/(^\?)/,'').split("&").map(function(n){return n = n.split("="),this[n[0]] = n[1],this}.bind({}))[0];
      }
    }
  };
})();



// WEBPACK FOOTER //
// ./public/javascripts/rwgps/utils.js